"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstanceUtils = void 0;
/**
 *
 * returns an interface to work with instances.
 */
const createInstanceUtils = ({ graphUtils, artifactInstances, }) => {
    /**
     *
     * MeshRun is a subset of pipelinerun.
     * Each pipelinerun can have multiple meshRuns.
     */
    const pipelineRunToMeshRuns = ({ pipelineRunRecord, }) => {
        const meshDocuments = graphUtils.toMeshDocuments();
        return meshDocuments.map((meshDocument) => {
            const [_unused, meshArtifactId] = meshDocument.meshDocumentId.split('_');
            return {
                pipelineRunRecord,
                id: `${pipelineRunRecord.id}_${meshArtifactId}`,
                cfSlugs: meshDocument.cfSlugs,
                lpSlugs: meshDocument.lpSlugs,
                status: 'success',
                artifactInstances: artifactInstances.filter(({ artifactId }) => meshDocument.artifacts.some(({ id }) => id === artifactId)),
            };
        });
    };
    return {
        pipelineRunToMeshRuns,
    };
};
exports.createInstanceUtils = createInstanceUtils;
//# sourceMappingURL=dbInstanceUtils.js.map